import React from 'react';
import './BillInfo.scss';
import { t } from 'localization';
import { Block } from 'components/Block';

export const BillInfo = (props) => {
  const { data } = props;
  const {
    booking_service_name: bookingServiceName,
    receiver_bill: receiverBill,
  } = data;

  const { total: totalReceiverBill } = receiverBill;

  return (
    <Block title={bookingServiceName} line>
      <div className='bill'>
        <div className='bill-type'>{t('recipient-pay')}</div>
        <div className='total'>
          <div>{t('total')}</div>
          <div>{totalReceiverBill.text}</div>
        </div>
      </div>
    </Block>
  );
};
